import { useEffect } from 'react';
import { IS_DEVELOPMENT } from '../constants';

export const DebugUtils = () => {
  useEffect(() => {
    // Load Eruda for mobile debugging in development only
    // As recommended in Base documentation: https://docs.base.org/base-app/build-with-minikit/debugging#using-eruda-for-mobile-debug
    const isDev = IS_DEVELOPMENT || 
      (typeof window !== 'undefined' && (
        window.location.hostname === 'localhost' || 
        window.location.hostname.includes('ngrok') ||
        window.location.hostname.includes('vercel.app')
      ));

    if (isDev) {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/eruda';
      script.onload = () => {
        if (window.eruda) {
          window.eruda.init();
          console.log('🔧 Eruda mobile debugging enabled for Alpha Pie');
        }
      };
      document.head.appendChild(script);

      return () => {
        // Cleanup
        try {
          document.head.removeChild(script);
        } catch (e) {
          // Script might have already been removed
        }
      };
    }
  }, []);

  return null; // This component doesn't render anything
}; 